import { buildPreviewDocument } from "containers/admin/clients/client/theme-configuration-page/theme-preview/templates/preview-document";
import {
  buildEmailBody,
  EMAIL_STYLES,
} from "containers/admin/clients/client/theme-configuration-page/theme-preview/templates/email-template";
import {
  getEmailThemeStyles,
  getThemeFontStylesheets,
  type PreviewSender,
} from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview.helpers";

import type { SavedTheme } from "hooks/api/use-theme";

type EmailPreviewDocumentArgs = {
  theme: SavedTheme | undefined;
  sender: PreviewSender;
  clientName: string;
  isBaseFontApplied: boolean;
};

/** The sample email with the theme applied, as a complete document for the preview frame. */
export const buildEmailPreviewDocument = ({
  theme,
  sender,
  clientName,
  isBaseFontApplied,
}: EmailPreviewDocumentArgs) =>
  buildPreviewDocument({
    body: buildEmailBody({ sender, bannerImageUrl: theme?.banner?.imageUrl, clientName }),
    styles: `${EMAIL_STYLES}\n${getEmailThemeStyles(theme, isBaseFontApplied)}`,
    isBaseFontApplied,
    fontStylesheets: getThemeFontStylesheets(theme),
  });
